import React from "react"
import { Link } from "react-router-dom"
import bgImage from "../images/4738654.png"

const LandingPage = () => {
  return (
    <>
      <div className="container pt-24 md:pt-48 px-6 mx-auto flex flex-wrap flex-col md:flex-row items-center">
        {/* left column */}
        <div className="flex flex-col w-full xl:w-2/5 justify-center lg:items-start overflow-y-hidden">
          <h1 className="my-4 text-3xl md:text-5xl text-purple-800 font-bold leading-tight text-center md:text-left slide-in-bottom-h1">
            Create awesome carousels in minutes
          </h1>
          <p className="leading-normal text-base md:text-2xl mb-8 text-center md:text-left slide-in-bottom-subtitle">
            Select from templates that makes your content look {" "}
            <span className="text-purple-800 font-bold">Spectacular</span>
          </p>

          <div className="flex w-full justify-center md:justify-start pb-24 lg:pb-0 fade-in">
            <Link to="/create">
              <button className="bg-purple-800 text-white p-3 rounded">
                Start for Free
              </button>
            </Link>
          </div>
        </div>

        {/* right column */}
        <div className="w-full xl:w-3/5 py-2 overflow-y-hidden">
          <img
            alt="bg_image"
            className="lg:w-2/3 sm:w-screen mx-auto"
            src={bgImage}
          />
        </div>

        {/* footer */}
        <div className="w-full pt-16 pb-6 text-sm text-center md:text-left fade-in">
          {/* eslint-disable-next-line */}
          <a className="text-gray-500 no-underline hover:no-underline" href="#">
            &copy; Greendotslab 2022
          </a>
        </div>
      </div>
    </>
  )
}

export default LandingPage
